import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import classnames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux'
import { select } from '../Redux/Actions'
import store from '../Redux';

import green from '@material-ui/core/colors/green';
import amber from '@material-ui/core/colors/amber';

import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import WarningIcon from '@material-ui/icons/Warning';

const styles = theme => ({
    snackbarItem: {
       position: 'relative',
       marginTop: "15px"
    },
    success: {
        backgroundColor: green[600],
    },
    error: {
      backgroundColor: theme.palette.error.dark,
    },
    info: {
        backgroundColor: theme.palette.primary.dark,
    },
    warning: {
        backgroundColor: amber[700],
    },
    message: {
        display: 'flex',
        alignItems: 'center',
    },
    iconVariant: {
        opacity: 0.9,
        marginRight: theme.spacing.unit,
    }
})

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
};

class SnackbarItem extends React.Component {

    state = {
        open: true
    }

    constructor(props) {
        super(props)
        this.state = {
            ...this.state, ...props
        }
    }

    closeSnackbar = () => {
        this.setState({
            open:false
        })
    }

    render() {

        var { classes } = this.props
        const Icon = variantIcon["success"]

        var {
            message, messageId, duration
        } = this.state

        return(
            <Snackbar
                anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                autoHideDuration={duration}
                open={this.state.open}
                onClose={this.closeSnackbar}
                className={classnames(classes.snackbarItem, "success")}
                ContentProps={{
                    'aria-describedby': {messageId},
                }}
                message={
                    <span id="client-snackbar" className={classes.message}>
                        <Icon className={classnames("success", classes.iconVariant)} />
                        {message}
                    </span>
                }
            />
        )
    }

}

class SnackbarContainer extends React.Component {

    state = {
        notifications: []
    }

    /*componentWillMount() {
        this.unsubscribe = store.subscribe(() => {
                var state = select(store.getState(), "notification")
                if(state.message === undefined) {
                    return
                }
                this.state.notifications.push(
                    <SnackbarItem
                        {...state}
                        classes={this.props.classes}
                        duration={2500}
                        messageId={new Date()}
                    />
                )
            }
        )
    }

    componentWillUnmount() {
        this.unsubscribe()
    }*/

    render() {
        return(
            <div className="snackbarContainer">
                {this.state.notifications}
            </div>
        )
    }

}

const mapStateToProps = state => ({
    data: state.notification
})
export default connect(
    mapStateToProps,
    {}
)(withStyles(styles)(SnackbarContainer));



// WEBPACK FOOTER //
// ./src/Components/SnackbarContainer.js